var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainHeader'),_c('div',{class:[
            ( _obj = {}, _obj[_vm.$style.veticalPadding] = !_vm.disableVerticalPadding, _obj[_vm.$style.horizontalPadding] = !_vm.disableHorizontalPadding, _obj ),
            _vm.$style.body ]},[_vm._t("default")],2),_c('div',{class:_vm.$style.footer},[_c('AppLink',{attrs:{"to":{
                path: '/privacy',
            }}},[_vm._v("Privacy Policy")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }